import type { LevelConfig, LevelLayer, LevelPiece, LevelPieceType } from "../level_config.js";

const CUBE = 1 as LevelPieceType;
const COMMON_DIFFICULTY = 0 as LevelConfig["difficulty"];

function wall( cols: number, rows: number ): LevelLayer
{
  const grid: number[][] = [];
  const pieces: LevelPiece[] = [];
  for ( let row = 0; row < rows; row++ )
  {
    const grid_row: number[] = [];
    for ( let col = 0; col < cols; col++ )
    {
      const id = row * cols + col + 1;
      grid_row.push( id );
      pieces.push( { id, type: CUBE, x: col, y: row, width: 1, height: 1 } );
    }
    grid.push( grid_row );
  }
  return { grid, pieces };
}

/**
 * Test levels for the Mine booster (sticky bombs). The debug console starts
 * them with the booster pre-selected, like the reference video: a solid wall
 * of 1x1 blocks the three mines blow apart without breaking any block.
 */
const MINE_LEVELS: Array<{ label: string; config: LevelConfig }> = [
  {
    label: "WALL 6x6, 2 LAYERS",
    config: { level: 90700, difficulty: COMMON_DIFFICULTY, layers: [ wall( 6, 6 ), wall( 6, 6 ) ] },
  },
  {
    label: "WALL 8x5, 1 LAYER",
    config: { level: 90701, difficulty: COMMON_DIFFICULTY, layers: [ wall( 8, 5 ) ] },
  },
  {
    label: "BLOCK 6x4, 3 LAYERS",
    config: { level: 90702, difficulty: COMMON_DIFFICULTY, layers: [ wall( 6, 4 ), wall( 6, 4 ), wall( 6, 4 ) ] },
  },
];

export class StickyMineShowcase
{
  public static readonly TESTS = MINE_LEVELS.map( entry => ( { label: entry.label, level: entry.config.level } ) );

  public static getConfig( level: number ): LevelConfig | null
  {
    return MINE_LEVELS.find( entry => entry.config.level === level )?.config ?? null;
  }
}
